<div class="list d-flex align-items-strech gap-{{gap}}">
    <ng-content></ng-content>
</div>